<template>
  <ion-content>
    <div class="row">
      <h1>Nicht Autorisiert</h1>
      <ion-icon
        size="large"
        name="sad"
        class="header-icon"
      />
    </div>
    <div>{{ email }} muss erst von einem Administrator freigeschalten werden</div>
    <ion-button @click="logout">
      Ausloggen
    </ion-button>
  </ion-content>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('auth');

export default {
  name: 'NotAuthenticated',
  computed: {
    ...mapState(['email']),
  },
  methods: mapActions(['logout']),
};
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  align-items: center;
}
.header-icon {
  margin-left: 8px;
}
</style>
